export const KPMG_REPORTING_ENABLED_METADATA_KEY = "is_kpmg_reporting_enabled";

type MetadataRecord = Record<string, string | boolean | null | undefined>;

export const isKpmgReportingEnabledInMetadata = (
  metadata?: MetadataRecord | null
): boolean => {
  if (metadata === undefined || metadata === null) {
    return true;
  }
  const raw = metadata[KPMG_REPORTING_ENABLED_METADATA_KEY];
  if (raw === false || raw === "false") {
    return false;
  }
  return true;
};

export const buildKpmgReportingMetadataUpdate = (
  existing: Record<string, string> | undefined,
  enabled: boolean
): Record<string, string> => ({
  ...(existing ?? {}),
  [KPMG_REPORTING_ENABLED_METADATA_KEY]: enabled ? "true" : "false",
});
